/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-10-12 15:35:16
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-10-15 09:32:16
 * @FilePath: \thatOpenTools\src\components\ifcViewer\index.tsx
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { forwardRef, Ref, useImperativeHandle, useRef, useState } from "react";
import { PageTextProvider } from "./ComponentContext";
import Viewer from "./components/Viewer";

function IfcViewer({}, ref: Ref<unknown> | undefined) {
  
  const viewerRef = useRef<any>(null);

  useImperativeHandle(ref, () => ({
    viewerRef: viewerRef.current,
  }));

  return (
    <PageTextProvider>
      <Viewer ref={viewerRef} />
    </PageTextProvider>
  );
}

export default forwardRef(IfcViewer);
